import script from "./CuisineView.vue?vue&type=script&setup=true&lang=js"
export * from "./CuisineView.vue?vue&type=script&setup=true&lang=js"

import "./CuisineView.vue?vue&type=style&index=0&id=6709a679&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6709a679"]])

export default __exports__